import { ReCAPTCHAV3_KEY } from 'Utils/Utils'
import { ReferralUaeAPIs } from './ReferralUaeAPIs'

const EXECUTE_TIMEOUT = 8000

let scriptPromise

// ponytail: load on first submit instead of preloading in App.js, so the v3 badge
// does not show up on every page of every market.
// Memoize on the promise only - never `if (window.grecaptcha) return`, because
// grecaptcha may come from the v2 script (render=explicit), which has no v3 key registered.
const loadScript = () => {
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            // ponytail: hide the floating v3 badge here rather than in a component - this is the
            // only place the badge is ever created, so it cannot be forgotten at a call site.
            // visibility, not display: display none has historically broken v3 execution.
            const badgeStyle = document.createElement('style')
            badgeStyle.innerHTML = '.grecaptcha-badge { visibility: hidden; }'
            document.head.appendChild(badgeStyle)

            const script = document.createElement('script')
            script.src = `https://www.google.com/recaptcha/api.js?render=${ReCAPTCHAV3_KEY}`
            script.onload = () => window.grecaptcha.ready(resolve)
            script.onerror = reject
            document.head.appendChild(script)
        })
    }

    return scriptPromise
}

/**
 * Runs reCAPTCHA v3 invisibly and lets the backend decide (the score threshold lives there).
 * Returns true when it passes, false when the caller should fall back to the v2 challenge.
 * Never throws.
 */
export const VerifyReCaptchaV3 = async (action = 'login') => {
    try {
        await loadScript()

        // ponytail: execute() can hang behind corporate proxies and leave the form dead forever
        const token = await Promise.race([
            window.grecaptcha.execute(ReCAPTCHAV3_KEY, { action }),
            new Promise((_, reject) => setTimeout(() => reject(new Error('recaptcha v3 timeout')), EXECUTE_TIMEOUT))
        ])

        const { data } = await ReferralUaeAPIs.verifyTokenRecaptchaV3(token)

        return data.gg_success === true && data.isAccepted === true && data.success === true
    } catch (e) {
        return false // fail closed to the v2 challenge, never block login outright
    }
}
